import React, { useEffect, useState } from "react";
import "./AdBanner.css"; // 引入樣式
import { getAds } from "../../services/api"; // 用於從後端獲取廣告內容

const AdBanner = () => {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await getAds();
        // 確保 response.data 是陣列
        const adsData = Array.isArray(response.data) ? response.data : [];
        setAds(adsData);
      } catch (err) {
        console.error("Failed to fetch ads:", err);
        // 錯誤時設為空陣列
        setAds([]);
      }
    };

    fetchAds();
  }, []);

  // 防護檢查：確保 ads 是陣列且有內容
  if (!Array.isArray(ads) || ads.length === 0) {
    return null;
  }

  return (
    <div className="ad-banner">
      {ads.map((ad, index) => {
        // 防護檢查：確保每個廣告對象有必要的屬性
        if (!ad || !ad.image_url) {
          return null;
        }

        return (
          <a
            key={ad.id || index}
            href={ad.link_url || '#'}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={ad.image_url}
              alt={ad.title || `Advertisement ${index + 1}`}
              loading="lazy"
              decoding="async"
              onError={(e) => {
                console.warn('Ad image failed to load:', ad.image_url);
                e.target.style.display = 'none';
              }}
            />
          </a>
        );
      })}
    </div>
  );
};

export default AdBanner;
